/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import DocumentTypeList from './DocumentTypeList';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import { getDocumentType, addDocumentType, editDocumentType, resetDocumentType } from '../actions/masterManagementAction';

const DocumentTypeForm = ({ addDocument, rowPerPage }) => {
    const { register, handleSubmit, errors } = useForm({
        mode: "onChange"
    });

    const [viewDocumentTypeList, setViewDocumentTypeList] = useState(false);

    const dispatch = useDispatch();
    useEffect(() => {
        if (addDocument > 0 && addDocument !== true) {
            dispatch(getDocumentType(addDocument));
        }
        // eslint-disable-next-line
    }, [])

    let { documentTypeDetails } = useSelector(
        (state) => state.masterManagementReducer,
        shallowEqual
    );

    const onSubmit = (data, setViewDocumentTypeList, addDocument) => {
        let requestBody = {};
        requestBody = {
            "id": "0",
            "name": data.documentName,
            "description": data.documentDescription,
            "isActive": data.isActive,
        }

        if (addDocument > 0 && addDocument !== true) {
            requestBody.id = addDocument;
            let documentTypes = {
                documentType: requestBody
            };
            dispatch(editDocumentType(documentTypes, setViewDocumentTypeList, rowPerPage));
        } else {
            let documentTypes = {
                documentType: requestBody
            };
            dispatch(addDocumentType(documentTypes, setViewDocumentTypeList, rowPerPage));
        }
    }

    return viewDocumentTypeList ? (
        <div>
            <DocumentTypeList />
        </div>
    ) : (
        <form>
            <div className="border border-light text-center w-100 p-5" >
                <div className='form-group'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <h4><p className='float-left'>{addDocument === true ? masterLabels.documentTypeMasterForm.Add_Doc_Type : masterLabels.documentTypeMasterForm.Upd_Doc_Type}</p></h4>
                        </div>
                    </div>
                </div>
                <br />
                <div className='form-group'>
                    <div className='row'>
                        <div className='form-group col-md-10'>
                            <label className='float-left font-weight-bold' >{masterLabels.documentTypeMasterForm.Doc_Type_Name_Field_Label}<span className="redColor">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="documentName"
                                placeholder="Name"
                                defaultValue={documentTypeDetails && documentTypeDetails.documentType && documentTypeDetails.documentType.name}
                                ref={register({
                                    required: true, maxLength: 500
                                })}
                            />
                            {_.get("documentName.type", errors) === "required" && (
                                <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                            )}
                            {_.get("documentName.type", errors) === "maxLength" && (
                                <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_500}</p>
                            )}
                        </div>
                        <div className='form-group col-md-2 mt-4'>
                            <div className="form-check d-flex align-items-center gap-5">
                                <label className='form-check-label font-weight-bold' htmlFor="isActiveCheckbox">
                                    {masterLabels.documentTypeMasterForm.Doc_Type_Active_Field_Label}?
                                </label>
                                <input
                                    className='form-check-input'
                                    type="checkbox"
                                    name="isActive"
                                    value={true}
                                    defaultChecked={documentTypeDetails?.documentType?.isActive}
                                    ref={register({})}
                                    id="isActiveCheckbox"
                                />
                            </div>
                        </div>


                        <div className='row'>
                        </div>
                        <div className='form-group col-md-12'>
                            <label className='float-left font-weight-bold' >{masterLabels.documentTypeMasterForm.Doc_Type_Description_Field_Label}<span className="redColor">*</span></label>
                            <textarea
                                className="form-control"
                                rows={3}
                                cols={5}
                                name="documentDescription"
                                placeholder="Description"
                                defaultValue={documentTypeDetails && documentTypeDetails.documentType && documentTypeDetails.documentType.description}
                                ref={register({ required: true, maxLength: 500 })}
                            />
                            {_.get("documentDescription.type", errors) === "required" && (
                                <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                            )}
                            {_.get("documentDescription.type", errors) === "maxLength" && (
                                <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_500}</p>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 d-flex justify-content-end">
                            <button type="button" className="btn btn-secondary"
                                onClick={() => { dispatch(resetDocumentType()); setViewDocumentTypeList(true) }}>
                                {commonLabels.BUTTONS.CANCEL}
                            </button>
                            <button type="submit" className=" btn btn-primary custom_button  ms-2  "
                                onClick={handleSubmit((e) => { onSubmit(e, setViewDocumentTypeList, addDocument) })}>
                                {commonLabels.BUTTONS.SAVE}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </form>
    );
}

export default DocumentTypeForm;